import {
  TRIGGER,
  type ChiDellaLista,
  type EmailAutomation,
  type TriggerKind,
} from '../../types/automazioni.types';
import type { NomiEtichette } from './disegnoSequenza';

/**
 * Da dove entrano i contatti in una sequenza: la scelta fatta creando la
 * sequenza, e poi cambiabile dalla casella "Si parte" finche' e' spenta.
 */
export interface Partenza {
  trigger: TriggerKind;
  /** Solo per la partenza da lista. Vuoto = non ancora scelta. */
  listaId: string;
  /** Solo per la partenza da lista. Null = non ancora scelta. */
  chi: ChiDellaLista | null;
}

/** Le sequenze da lista salvate prima di questa scelta facevano entrare solo
 *  i nuovi: senza scelta scritta, vale quello. */
export function chiDellaLista(automazione: Pick<EmailAutomation, 'trigger_config'>): ChiDellaLista {
  return automazione.trigger_config?.chi === 'tutta' ? 'tutta' : 'nuovi';
}

/** La partenza come la vede chi la sceglie. */
export function partenzaDi(
  automazione: Pick<EmailAutomation, 'trigger_kind' | 'trigger_config'>
): Partenza {
  return {
    trigger: automazione.trigger_kind,
    listaId: automazione.trigger_config?.tag_id ?? '',
    chi: chiDellaLista(automazione),
  };
}

/** Quello che finisce nella colonna trigger_config. */
export function configPartenza(partenza: Partenza): EmailAutomation['trigger_config'] {
  if (partenza.trigger !== 'etichetta_aggiunta') return {};
  return {
    ...(partenza.listaId ? { tag_id: partenza.listaId } : {}),
    chi: partenza.chi ?? 'nuovi',
  };
}

/** Vero se la scelta e' finita: per la lista servono la lista e chi entra. */
export function partenzaCompleta(partenza: Partenza): boolean {
  if (partenza.trigger !== 'etichetta_aggiunta') return true;
  return partenza.listaId !== '' && partenza.chi !== null;
}

/** Da dove entrano i contatti, detto a parole, per la testata e per "Si parte". */
export function descriviPartenza(
  automazione: Pick<EmailAutomation, 'trigger_kind' | 'trigger_config'>,
  nomi: NomiEtichette
): string {
  const tagId = automazione.trigger_config?.tag_id;
  if (automazione.trigger_kind === 'etichetta_aggiunta' && tagId && nomi[tagId]) {
    return chiDellaLista(automazione) === 'tutta'
      ? `Tutta la lista "${nomi[tagId]}"`
      : `Chi aggiungo da ora alla lista "${nomi[tagId]}"`;
  }
  return TRIGGER[automazione.trigger_kind].label;
}

/** Vero se accendendo entrano subito i contatti gia' nella lista. */
export function entraTuttaLaLista(
  automazione: Pick<EmailAutomation, 'trigger_kind' | 'trigger_config'>
): boolean {
  return automazione.trigger_kind === 'etichetta_aggiunta' && chiDellaLista(automazione) === 'tutta';
}
